import EtheriumGold from "./ethereum-gold.svg"
import SuccessMessage from "./success-not.svg"
import DiscordWhite from "./discord-white.svg"
import RejectMessage from "./reject-not.svg"
import Telegram from "./telegram-white.svg"
import UnCheck from "./select-uncheck.svg"
import CloseSmall from "./close-small.svg"
import MenuFilter from "./Group 533.svg"
import Close from "./icons8-close.svg"
import Facebook from "./facebook.svg"
import LeftPage from "./leftPage.svg"
import Currency from "./currency.svg"
import X from "./twitter-x-white.svg"
import Discord from "./discord.svg"
import Success from "./success.svg"
import Require from "./require.svg"
import Google from "./google.svg"
import Reject from "./reject.svg"
import Minus from "./minus.svg"
import Apple from "./apple.svg"
import PLus from "./plus.svg"
import Edit from "./edit.svg"
import Eth from "./eth.svg"
import No from "./no.svg"

import {ReactComponent as WalletDisconnect} from "./wallet-disconnect.svg"
import {ReactComponent as FacebookStatic} from "./facebook-static.svg"
import {ReactComponent as TelegramStatic} from "./telegram-static.svg"
import {ReactComponent as TwitterXWhite} from "./twitter-x-white.svg"
import {ReactComponent as TelegramBlack} from "./telegram-black.svg"
import {ReactComponent as YoutubeStatic} from "./youtube-static.svg"
import {ReactComponent as DiscordStatic} from "./discord-static.svg"
import {ReactComponent as NoEligibility} from "./no-eligibility.svg"
import {ReactComponent as TelegramWhite} from "./telegram-white.svg"
import {ReactComponent as PasswordHide} from "./password-close.svg"
import {ReactComponent as TikTokStatic} from "./tiktok-static.svg"
import {ReactComponent as DiscordBlack} from "./discord-black.svg"
import {ReactComponent as PasswordOpen} from "./password-open.svg"
import {ReactComponent as SuccessCheck} from "./success-check.svg"
import {ReactComponent as DiscordBlue} from "./discord-blue.svg"
import {ReactComponent as SelectArrow} from "./select-arrow.svg"
import {ReactComponent as KompeteCoin} from "./kompete-coin.svg"
import {ReactComponent as RightSymbol} from "./right-symbol.svg"
import {ReactComponent as XboxDefault} from "./xbox-default.svg"
import {ReactComponent as GooglePlay} from "./google-playe.svg"
import {ReactComponent as UnTradeable} from "./unTradeable.svg"
import {ReactComponent as Eligibility} from "./eligibility.svg"
import {ReactComponent as Playstation} from "./playstation.svg"
import {ReactComponent as EthereumG} from "./ethereum-gold.svg"
import {ReactComponent as SuccessIcon} from "./success-v2.svg"
import {ReactComponent as OwnedItems} from "./owned-items.svg"
import {ReactComponent as VoolahName} from "./voolah-name.svg"
import {ReactComponent as LeftSymbol} from "./left-symbol.svg"
import {ReactComponent as VoolahCoin} from "./voolah-coin.svg"
import {ReactComponent as LocationBack} from "./location.svg"
import {ReactComponent as Activities} from "./activities.svg"
import {ReactComponent as CloseIcon} from "./close-small.svg"
import {ReactComponent as PhoneBack} from "./phone-back.svg"
import {ReactComponent as BaseChain} from "./base-chain.svg"
import {ReactComponent as EpicGames} from "./epic-games.svg"
import {ReactComponent as NextArrow} from "./next-arrow.svg"
import {ReactComponent as PrevArrow} from "./prev-arrow.svg"
import {ReactComponent as SuccessV2} from "./success-v2.svg"
import {ReactComponent as Tradeable} from "./tradeable.svg"
import {ReactComponent as Modernize} from "./modernize.svg"
import {ReactComponent as Protected} from "./protected.svg"
import {ReactComponent as EthChain} from "./eth-chain.svg"
import {ReactComponent as SuccessSvg} from "./success.svg"
import {ReactComponent as TwitterX} from "./twitter-x.svg"
import {ReactComponent as Select} from "./select-down.svg"
import {ReactComponent as CartLine} from "./cart-line.svg"
import {ReactComponent as AppStore} from "./app-store.svg"
import {ReactComponent as DeleteIcon} from "./delete.svg"
import {ReactComponent as Cooldown} from "./cooldown.svg"
import {ReactComponent as Increase} from "./increase.svg"
import {ReactComponent as Scarcity} from "./scarcity.svg"
import {ReactComponent as WalletIcon} from "./wallet.svg"
import {ReactComponent as Activity} from "./activity.svg"
import {ReactComponent as GamePad} from "./game-pad.svg"
import {ReactComponent as Left} from "./ctrl-left 1.svg"
import {ReactComponent as GoogleSVG} from "./google.svg"
import {ReactComponent as Profile} from "./profile.svg"
import {ReactComponent as Display} from "./display.svg"
import {ReactComponent as Android} from "./android.svg"
import {ReactComponent as Refresh} from "./refresh.svg"
import {ReactComponent as Loading} from "./loading.svg"
import {ReactComponent as AppleSVG} from "./apple.svg"
import {ReactComponent as Weapon} from "./weapons.svg"
import {ReactComponent as EditV2} from "./edit-v2.svg"
import {ReactComponent as NoData} from "./no-data.svg"
import {ReactComponent as EditIcon} from "./edit.svg"
import {ReactComponent as Origin} from "./origin.svg"
import {ReactComponent as Window} from "./window.svg"
import {ReactComponent as Search} from "./search.svg"
import {ReactComponent as Divine} from "./divine.svg"
import {ReactComponent as Filter} from "./filter.svg"
import {ReactComponent as LogOut} from "./logout.svg"
import {ReactComponent as Ethereum} from "./eth.svg"
import {ReactComponent as Phone} from "./phone.svg"
import {ReactComponent as Price} from "./price.svg"
import {ReactComponent as ZhTW} from "./zh-TW.svg"
import {ReactComponent as ZhCN} from "./zh-CN.svg"
import {ReactComponent as Sort} from "./sort.svg"
import {ReactComponent as Info} from "./info.svg"
import {ReactComponent as Fire} from "./fire.svg"
import {ReactComponent as Bot} from "./bot.svg"
import {ReactComponent as Pc} from "./pc.svg"
import {ReactComponent as De} from "./de.svg"
import {ReactComponent as En} from "./en.svg"
import {ReactComponent as Es} from "./es.svg"
import {ReactComponent as Fr} from "./fr.svg"
import {ReactComponent as Hi} from "./hi.svg"
import {ReactComponent as Id} from "./id.svg"
import {ReactComponent as It} from "./it.svg"
import {ReactComponent as Ja} from "./ja.svg"
import {ReactComponent as Ko} from "./ko.svg"
import {ReactComponent as Nl} from "./nl.svg"
import {ReactComponent as Pl} from "./pl.svg"
import {ReactComponent as Pt} from "./pt.svg"
import {ReactComponent as Ru} from "./ru.svg"
import {ReactComponent as Sv} from "./sv.svg"
import {ReactComponent as Th} from "./th.svg"
import {ReactComponent as Tr} from "./tr.svg"
import {ReactComponent as Vi} from "./vi.svg"

export {
    Info,
    EditIcon,
    SuccessV2,
    DeleteIcon,
    WalletIcon,
    SuccessIcon,
}

export const SVG = {
    walletDisconnect: WalletDisconnect,
    telegramBlack: TelegramBlack,
    noEligibility: NoEligibility,
    twitterXWhite: TwitterXWhite,
    telegramWhite: TelegramWhite,
    discordBlack: DiscordBlack,
    passwordHide: PasswordHide,
    passwordOpen: PasswordOpen,
    locationBack: LocationBack,
    successCheck: SuccessCheck,
    eligibility: Eligibility,
    telegram: TelegramStatic,
    facebook: FacebookStatic,
    rightSymbol: RightSymbol,
    unTradeable: UnTradeable,
    playstation: Playstation,
    discordBlue: DiscordBlue,
    selectArrow: SelectArrow,
    activities: Activities,
    ownedItems: OwnedItems,
    discord: DiscordStatic,
    youtube: YoutubeStatic,
    leftSymbol: LeftSymbol,
    googlePlay: GooglePlay,
    voolahName: VoolahName,
    phoneBack: PhoneBack,
    kompete: KompeteCoin,
    ethereumG: EthereumG,
    tiktok: TikTokStatic,
    tradeable: Tradeable,
    modernize: Modernize,
    epicGames: EpicGames,
    prevArrow: PrevArrow,
    nextArrow: NextArrow,
    baseChain: BaseChain,
    protected: Protected,
    success: SuccessSvg,
    ethChain: EthChain,
    voolah: VoolahCoin,
    activity: Activity,
    increase: Increase,
    twitterX: TwitterX,
    cartLine: CartLine,
    appStore: AppStore,
    cooldown: Cooldown,
    scarcity: Scarcity,
    xbox: XboxDefault,
    google: GoogleSVG,
    twitter: TwitterX,
    gamePad: GamePad,
    display: Display,
    android: Android,
    refresh: Refresh,
    close: CloseIcon,
    profile: Profile,
    loading: Loading,
    apple: AppleSVG,
    noData: NoData,
    origin: Origin,
    weapon: Weapon,
    window: Window,
    search: Search,
    divine: Divine,
    select: Select,
    filter: Filter,
    logOut: LogOut,
    editV2: EditV2,
    eth: Ethereum,
    phone: Phone,
    price: Price,
    "zh-TW": ZhTW,
    "zh-CN": ZhCN,
    sort: Sort,
    left: Left,
    fire: Fire,
    bot: Bot,
    pc: Pc,
    de: De,
    en: En,
    es: Es,
    fr: Fr,
    hi: Hi,
    id: Id,
    it: It,
    ja: Ja,
    ko: Ko,
    nl: Nl,
    pl: Pl,
    pt: Pt,
    ru: Ru,
    sv: Sv,
    th: Th,
    tr: Tr,
    vi: Vi,
}

export const svg = {
    SuccessMessage,
    RejectMessage,
    EtheriumGold,
    DiscordWhite,
    CloseSmall,
    MenuFilter,
    Facebook,
    Telegram,
    LeftPage,
    Currency,
    UnCheck,
    Discord,
    Require,
    Success,
    Google,
    Reject,
    Close,
    Minus,
    Apple,
    Left,
    PLus,
    Edit,
    Eth,
    No,
    X
}
